<template>
  <div class="row-fluid">
    <loading :active.sync="callingAPI" :can-cancel="false" :is-full-page="fullPage" loader="bars" color="#346cb0" :width="40"></loading>
    <div class="col-md-12 right-panel">
      <img src="assets/images/logo_onetrace.svg" alt="OneTrace" width="240">
      <div class="form-content width-small">

        <div class="row form-info text-center">
          <div class="col-12" style="color: #555555">
            <h4><strong>Verification</strong></h4>
            <p>To reset your password, please input your username and the verification code you received in your
              email.</p>
          </div>
        </div>

        <form class="login-form" method="post" >
          <div class="form-group" style="margin-bottom: 0;">
            <div class="input-group input-group-icon mt-10">
              <input id="username" name="username" type="text" class="form-control" placeholder="Username" tabindex="1" v-model="data.username"
                     required>
              <span class="input-group-addon">
                <em class="fa fa-user"></em>
                </span>
            </div>

            <div class="input-group input-group-icon mt-10">
              <input id="verification_code" name="verification_code" type="text" class="form-control" v-model="data.verification_code"
                     placeholder="Verification Code" tabindex="1" required>
              <span class="input-group-addon">
                <em class="fa fa-qrcode"></em>
                </span>
            </div>

            <div class="input-group input-group-icon mt-10" id="new_password_block">
              <input id="new_password" name="new_password" type="password" class="form-control" v-model="data.new_pass"
                     placeholder="New Password" tabindex="1" required @keyup="checkFormLive">
              <span class="input-group-addon togglePassword" @click="readPassword">
                <em class="fa fa-eye-slash"></em>
                </span>
            </div>
            <div class="form-row">
              <span id="new_password_msg" class="help-block"></span>
              <div style="padding: 0 0 10px;display: block;">
                <ul style="list-style-type: none; line-height: 20px;margin:0; padding: 0;font-size: 0.9em;">
                  <li id="numberColor" style="color: red;">
                    <span class="fa fa-check-circle" id="number"></span> One number ( <strong>0-9</strong> )
                  </li>
                  <li id="upcaseColor" style="color: red;">
                    <span class="fa fa-check-circle" id="upcase"></span> One uppercase letter ( <strong>A-Z</strong> )
                  </li>
                  <li id="locaseColor" style="color: red;">
                    <span class="fa fa-check-circle" id="locase"></span> One lowercase letter ( <strong>a-z</strong> )
                  </li>
                  <li id="symbolColor" style="color: red;">
                    <span class="fa fa-check-circle" id="symbol"></span> One symbol (
                    <strong>`~!@#$%^-_+()[]{}:.?</strong> )
                  </li>
                  <li id="charColor" style="color: red;">
                    <span class="fa fa-check-circle" id="char"></span> Min 8 chars
                  </li>
                </ul>
              </div>
            </div>

            <div class="input-group input-group-icon">
              <input id="confirm_new_password" name="confirm_new_password" type="password" class="form-control" v-model="data.confirm_new_pass"
                     placeholder="Confirm New Password" tabindex="1" required>
              <span class="input-group-addon togglePassword" @click="readPassword">
                <em class="fa fa-eye-slash"></em>
                </span>
            </div>
          </div>

          <div class="form-group mt-40">
            <button type="submit" id="btnSubmit" class="btn btn-block st-button text-uppercase" @click="changePassword">
              Reset Password
            </button>
          </div>

          <div class="form-text text-center mt-40" style="color: #555555">
            <em class="fa fa fa-long-arrow-alt-left"></em>
            <a href="/login" class="primary-color">
              Return to Log in Page
            </a>
          </div>
        </form>
      </div>
    </div>
  </div>

</template>

<script>
import AxiosCall from "../../libs/AxiosCall";
import {urlApi} from "../../config/url-api";
import {mapGetters} from 'vuex'
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: "ChallengePassword",
  components:{
    Loading
  },
  data(){
    return{
      data : {
        username:"",
        verification_code:"",
        new_pass:"",
        confirm_new_pass:"",
      },
      fullPage: true
    }
  },
  computed:{
    ...mapGetters(['callingAPI'])
  },
  methods:{
    changePassword(e){
      e.preventDefault()
      if(!this.checkForm()){
        return
      }
      let payload = this.data
      AxiosCall.Post(payload, urlApi.auth.change_password).then(res=>{
        if(res.success){
          this.$root.$children[0].successMessage(res.message)
          this.$router.push({path:"/login"})
        }else{
          this.$root.$children[0].errorMessage(res.message)
        }
      }).catch(err=>{
        this.$root.$children[0].errorMessage(err.response.data.message)
      })
    },
    checkFormLive(){
      let numberColor = document.getElementById("numberColor");
      let upcaseColor = document.getElementById("upcaseColor");
      let locaseColor = document.getElementById("locaseColor");
      let symbolColor = document.getElementById("symbolColor");
      let charColor = document.getElementById("charColor");
      let newPass = document.getElementById("new_password");

      charColor.style.color = "red";
      numberColor.style.color = "red";
      locaseColor.style.color = "red";
      upcaseColor.style.color = "red";
      symbolColor.style.color = "red";
      let re
      if(newPass.value != "") {
        if(newPass.value.length >= 8) {
          charColor.style.color = "green";
        }
        re = /[0-9]/;
        if(re.test(newPass.value)) {
          numberColor.style.color = "green";
        }
        re = /[a-z]/;
        if(re.test(newPass.value)) {
          locaseColor.style.color = "green";
        }
        re = /[A-Z]/;
        if(re.test(newPass.value)) {
          upcaseColor.style.color = "green";
        }
        re = /[\`~\!@\#$\%^\-_\+(\)[\]{\}:\.?]/gm;
        if(re.test(newPass.value)) {
          symbolColor.style.color = "green";
        }
      }
    },
    checkForm(){
      let msg = document.getElementById("new_password_msg");
      let block = document.getElementById("new_password_block");
      block.className += " has-error";

      let re
      if(this.data.new_pass != "" && this.data.verification_code != "" && this.data.new_pass == this.data.confirm_new_pass) {
        if(this.data.new_pass.length < 8) {
          msg = "Password must contain at least 8 characters!";
          this.$root.$children[0].errorMessage(msg)
          return false;
        }
        if(this.data.new_pass == this.data.username) {
          msg = "Password must be different from Username!";
          this.$root.$children[0].errorMessage(msg)
          return false;
        }
        re = /[0-9]/;
        if(!re.test(this.data.new_pass)) {
          msg = "Password must contain at least one number (0-9)!";
          this.$root.$children[0].errorMessage(msg)
          return false;
        }
        re = /[\`~\!@\#$\%^\-_\+(\)[\]{\}:\.?]/gm;
        if(!re.test(this.data.new_pass)) {
          msg = "Password must contain at least one symbol  `~!@#$%^-_+()[]{}:.?";
          this.$root.$children[0].errorMessage(msg)
          return false;
        }
        re = /[a-z]/;
        if(!re.test(this.data.new_pass)) {
          msg = "Password must contain at least one lowercase letter (a-z)!";
          this.$root.$children[0].errorMessage(msg)
          return false;
        }
        re = /[A-Z]/;
        if(!re.test(this.data.new_pass)) {
          msg = "Password must contain at least one uppercase letter (A-Z)!";
          this.$root.$children[0].errorMessage(msg)
          return false;
        }
      } else {
        msg = "Please check that you've entered and confirmed your password!";
        this.$root.$children[0].errorMessage(msg)
        return false;
      }
      return true;
    },
    readPassword(){
      let x = document.getElementById("new_password");
      let y = document.getElementById("confirm_new_password");
      if (x.type === "password" || y.type === "password") {
        x.type = "text";
        y.type = "text";
        $('.togglePassword > i').removeClass('fa-eye-slash');
        $('.togglePassword > i').addClass('fa-eye');
      } else {
        x.type = "password";
        y.type = "password";
        $('.togglePassword > i').removeClass('fa-eye');
        $('.togglePassword > i').addClass('fa-eye-slash');
      }
    }
  }
}
</script>

<style scoped>
.right-panel {
  display: flex;
  flex-direction: column;
  height: 100vh;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.form-content.width-small {
  width: 400px;
}


.form-content {
  margin-top: 10px;
}

.form-info {
  margin: 10px 0 20px;
}

.form-info h4 {
  font-weight: 900;
}

.form-info h4, .form-info p {
  margin: 0;
}

h4, .h4 {
  font-size: 18px;
}

.input-group-addon {
  padding: 10px 12px;
  font-size: 14px;
  font-weight: normal;
  line-height: 1;
  color: #555555;
  text-align: center;
  border-radius: 4px;
}

.primary-color {
  color: #EF7D22;
}

.st-button {
  font-family: 'Open Sans', sans-serif;
  font-weight: 700;
  background-color: #EF7D22;
  color: #f0f0f0;
  border-radius: 100px;
}

.text-uppercase {
  text-transform: uppercase;
}

.btn-block {
  display: block;
  width: 100%;
}

.horizontal-divider {
  width: 100%;
  height: 1px;
  border-top: 1px solid #ddd;
  margin: 20px 0;
}
.horizontal-divider span {
  background: #f3f5f4;
  position: relative;
  left: 45%;
  top: -12px;
  padding: 1px 10px;
}

.login-form .form-text {
  font-size: 13px;
}
.mt-40 {
  margin-top: 40px !important;
}
.text-center {
  text-align: center;
}
.mt-10 {
  margin-top: 10px !important;
}

.help-block {
  display: block;
  margin-top: 5px;
  margin-bottom: 10px;
  color: #737373;
}
.togglePassword {
  cursor: pointer;
}
</style>